import { AppState } from "../app.state";

export const getLogoutStatus = (state: AppState) => state.logout.loadStatus;
